<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />
      <p class="mb-4">{{ $t('master.textSpareParts') }}</p>
      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <McButtonBack />
        </div>
      </div>
    </div>

    <b-card class="mc-card__setting">
      <b-tabs content-class="p-3 text-muted">
        <b-tab @click="selectedTab = 'parts'" :active="selectedTab == 'parts'">
          <template v-slot:title>
            <span class="d-none d-sm-inline-block">
              {{ $t('global.object.parts') }}
            </span>
          </template>
          <Parts v-if="selectedTab == 'parts'" ref="partsTableRef" class="pb-0" />
        </b-tab>

        <b-tab @click="selectedTab = 'services'" :active="selectedTab == 'services'">
          <template v-slot:title>
            <span class="d-none d-sm-inline-block">
              {{ $t('global.service') }}
            </span>
          </template>
          <Service v-if="selectedTab == 'services'" ref="serviceTableRef" class="pb-0" />
        </b-tab>
      </b-tabs>
    </b-card>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import Parts from './parts'
import Service from './maintenance'
import McButtonBack from '@/components/McButtonBack'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Servis',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Service,
    Parts,
    McButtonBack,
  },

  data() {
    return {
      selectedTab: 'parts',
      loading: true,
    }
  },

  computed: {
    title() {
      return this.$t('master.maintenance')
    },
    tabOptions() {
      return [
        {
          text: this.$t('global.object.parts'),
          value: 'parts',
        },
        {
          text: this.$t('global.service'),
          value: 'service',
        },
      ]
    },
  },
}
</script>
